import { render, staticRenderFns } from "./CalculationsHistoryHandler.vue?vue&type=template&id=c5c7be5c&scoped=true&"
import script from "./CalculationsHistoryHandler.vue?vue&type=script&lang=js&"
export * from "./CalculationsHistoryHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c7be5c",
  null
  
)

export default component.exports